import _taggedTemplateLiteral from "G:/Work/Primary360/ahdc-squid/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject49() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-right: auto;\n  width: 98%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  min-height: 3rem;\n\n  filter: ", ";\n\n  &.hide {\n    visibility: hidden;\n  }\n\n  &.show {\n    visibility: visible;\n  }\n"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 3px;\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  position: absolute;\n  right: 0;\n  width: 100%;\n"]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  left: 0;\n  position: absolute;\n  transition: all 0.2s ease;\n\n  &.vertical {\n    align-items: flex-start;\n    height: 100%;\n    justify-content: flex-start;\n    width: 100%;\n  }\n"]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  display: flex;\n  justify-content: center;\n  overflow-y: ", ";\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n  position: relative;\n  scroll-behavior: smooth;\n  scrollbar-color: ", " default;\n  scrollbar-width: thin;\n  width: 100%;\n  padding: ", ";\n\n  &::-webkit-scrollbar {\n    width: 0.5em;\n    height: 0;\n  }\n\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    outline: 1px solid ", ";\n  }\n\n  &.horizontal {\n    height: 6rem;\n  }\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  /* cannot remove this */\n  height: 100%;\n  outline: 0;\n  overflow: hidden;\n  position: relative;\n  user-select: none;\n  width: 100%;\n\n  ", ";\n\n  &.horizontal {\n    justify-content: flex-start;\n  }\n\n  &.js-focus-visible :focus:not(.focus-visible) {\n    outline: none;\n  }\n\n  &.js-focus-visible .focus-visible {\n    outline: 2px solid #528deb;\n  }\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: ", ";\n  ", ";\n\n  &.left {\n    justify-content: ", ";\n    order: ", ";\n  }\n\n  &.right {\n    ", ";\n  }\n"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n  visibility: hidden;\n\n  ", "\n\n  ", "\n\n  \n\n  &.visible {\n    visibility: visible;\n    animation: ", " 0.25s ease-in;\n  }\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  width: 10%;\n\n  &.left {\n    order: 2;\n  }\n\n  &.right {\n    order: 1;\n  }\n\n  &::after {\n    background: ", ";\n    content: '';\n    display: block;\n    height: 100%;\n    left: 0;\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    right: 0;\n    width: 3px;\n    z-index: 0;\n  }\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  visibility: hidden;\n  width: 100%;\n  align-items: stretch;\n\n  &.left {\n    margin-right: auto;\n  }\n  &.right {\n    margin-left: auto;\n  }\n\n  &.visible {\n    visibility: visible;\n  }\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    visibility: hidden;\n  }\n  to {\n    opacity: 1;\n    visibility: visible;\n  }\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 1em;\n  outline: 0;\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  visibility: hidden;\n\n  &.vertical {\n    margin-bottom: 2rem;\n    width: 100%;\n  }\n\n  &.visible {\n    visibility: visible;\n  }\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 1em;\n  width: 100%;\n  &.vertical {\n    flex-direction: column;\n  }\n  &.horizontal {\n    flex-direction: row;\n  }\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  animation: ", " 0.25s ease-in;\n\n  &.horizontal {\n    min-width: 400px;\n  }\n\n  &.vertical {\n    width: calc(100% - 5em);\n    margin-left: auto;\n    flex-direction: column;\n  }\n"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  &.vertical {\n    margin-bottom: 1em;\n  }\n\n  &.horizontal {\n    position: absolute;\n    bottom: 2em;\n  }\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  height: 1em;\n  width: 1em;\n\n  &.active {\n    animation: ", " 0.1s ease-in;\n    transform: scale(1.4);\n\n    &::after {\n      background: ", ";\n      border-radius: 50%;\n      content: '';\n      display: block;\n      height: 0.75em;\n      left: 50%;\n      position: absolute;\n      right: 0;\n      top: 50%;\n      transform: translateY(-50%) translateX(-50%);\n      width: 0.75em;\n      z-index: -1;\n    }\n  }\n\n  &.in-active {\n    animation: ", " 0.1s ease-in;\n    transform: scale(1);\n  }\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  /* height: 100%; */\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 5em;\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: scale(1.4);\n  }\n  to {\n    transform: scale(1);\n  }\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(1.4);\n  }\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  border: 1px solid transparent;\n  display: flex;\n  justify-content: center;\n  position: relative;\n\n  &.vertical {\n    justify-content: flex-start;\n  }\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0.2rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  overflow: hidden;\n  padding: 0.25rem;\n  visibility: ", ";\n  text-align: ", ";\n\n  &.active {\n    background: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  color: #a3a3a3;\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 50%;\n  transform: translateY(-50%);\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  /* position: absolute; */\n  bottom: -1em;\n  left: 0;\n  right: 0;\n  /* margin-left: auto; */\n  margin-right: auto;\n  width: ", ";\n  /* min-height: 100px; */\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  border-radius: 6px;\n  padding-bottom: 0.5em;\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n  max-height: 100%;\n  margin-left: auto;\n  margin-right: auto;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  flex: 4;\n  justify-self: center;\n  margin-left: auto;\n  margin-right: auto;\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n  visibility: ", ";\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  align-items: center;\n  align-self: center;\n  background: ", ";\n  border-radius: 4px;\n  flex-direction: row;\n  height: 0;\n  padding: 0.5em;\n  pointer-events: ", ";\n  position: relative;\n  text-align: center;\n  width: 100%;\n\n  ", "\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  height: 1em;\n  justify-content: center;\n  margin-left: 0.2em;\n  margin-top: 0.2em;\n  width: 1em;\n  ", ";\n\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n        animation-play-state: paused;\n        width: ", "px;\n      "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n        animation: ", " ", "ms ease-in;\n        animation-play-state: running;\n      "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  bottom: -0.75em;\n  display: block;\n  height: 3px;\n  left: 0;\n  position: absolute;\n\n  ", "\n\n  svg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    width: ", "px;\n  }\n  100% {\n    width: ", "px;\n  }  \n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  align-self: flex-end;\n  background: #f5f5f5;\n  border-radius: 4px;\n  cursor: pointer;\n  display: ", ";\n  font-size: 0.75rem;\n  justify-self: flex-end;\n  margin-bottom: 0.5em;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n  margin-top: auto;\n  padding: 0.1em 0.5em;\n\n  &:hover {\n    background: ", ";\n    color: #fff;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  font-size: 0.8rem;\n  margin: 0 auto;\n  margin-bottom: 0.5em;\n  ", "\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-color: ", " default;\n  scrollbar-width: thin;\n  transition: max-height 150ms linear;\n  width: 97%;\n  padding: 0.2em 0.2em;\n\n  &.show-less {\n    max-height: 50px;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      width: 0;\n    }\n    overflow: hidden;\n  }\n\n  &::-webkit-scrollbar {\n    width: 0.3em;\n  }\n\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    outline: 1px solid ", ";\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  color: #191919;\n  font-size: 0.85rem;\n  font-weight: 400;\n  margin: 0;\n  touch-action: none;\n  width: 100%;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: #323232;\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n  margin-top: 0.5em;\n  padding-left: 0.5em;\n  &.active {\n    color: ", ";\n  }\n  text-align: left;\n  width: 95%;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.85rem;\n  font-weight: 600;\n  margin: 0;\n  padding-left: 0.5rem;\n  text-align: left;\n  width: 97%;\n  color: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  background: #fff;\n  border-radius: 4px;\n  display: flex;\n  filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.2));\n  flex-direction: column;\n  justify-content: flex-start;\n  line-height: 1.5em;\n  margin: ", ";\n  position: relative;\n  text-align: left;\n  width: 100%;\n\n  &:focus {\n    outline: 1px solid ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  height: 2em;\n  justify-content: center;\n  margin-left: 0.5em;\n  width: 2em;\n  outline: 0;\n  color: #fff;\n\n  svg {\n    width: 80%;\n    height: 80%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  visibility: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 50%;\n  border: 0;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.25));\n  height: 2em;\n  justify-content: center;\n  margin: 0 0.2em;\n  padding: 0;\n  transition: all 0.1s ease-in;\n  width: 2em;\n\n  transform: ", ";\n\n  &:active {\n    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.25));\n    transform: ", " scale(0.9);\n  }\n\n  svg {\n    width: 80%;\n    height: 80%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: rgba(229, 229, 229, 0.85);\n  border-radius: 25px;\n  display: flex;\n  list-style: none;\n  padding: 0.25em 0.25em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/*
 * react-chrono
 * A Modern Timeline component for React
 * v1.7.3
 * MIT License
 */
import { nanoid } from 'nanoid';
import React, { useState, useMemo, useContext, createElement, Fragment as Fragment$1, createContext, forwardRef, useRef, useEffect, useCallback, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function require(path, base) {
      return commonjsRequire(path, base === undefined || base === null ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var focusVisible = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory();
  })(commonjsGlobal, function () {
    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */
    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        'datetime-local': true
      };
      /**
       * Helper function for legacy browsers and iframes which sometimes focus
       * elements like document, body, and non-interactive SVG.
       * @param {Element} el
       */

      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
          return true;
        }

        return false;
      }
      /**
       * Computes whether the given element should automatically trigger the
       * `focus-visible` class being added, i.e. whether it should always match
       * `:focus-visible` when focused.
       * @param {Element} el
       * @return {boolean}
       */


      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;

        if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
          return true;
        }

        if (tagName === 'TEXTAREA' && !el.readOnly) {
          return true;
        }

        if (el.isContentEditable) {
          return true;
        }

        return false;
      }
      /**
       * Add the `focus-visible` class to the given element if it was not added by
       * the author.
       * @param {Element} el
       */


      function addFocusVisibleClass(el) {
        if (el.classList.contains('focus-visible')) {
          return;
        }

        el.classList.add('focus-visible');
        el.setAttribute('data-focus-visible-added', '');
      }
      /**
       * Remove the `focus-visible` class from the given element if it was not
       * originally added by the author.
       * @param {Element} el
       */


      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute('data-focus-visible-added')) {
          return;
        }

        el.classList.remove('focus-visible');
        el.removeAttribute('data-focus-visible-added');
      }
      /**
       * If the most recent user interaction was via the keyboard;
       * and the key press did not include a meta, alt/option, or control key;
       * then the modality is keyboard. Otherwise, the modality is not keyboard.
       * Apply `focus-visible` to any current active element and keep track
       * of our keyboard modality state with `hadKeyboardEvent`.
       * @param {KeyboardEvent} e
       */


      function onKeyDown(e) {
        if (e.metaKey || e.altKey || e.ctrlKey) {
          return;
        }

        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }

        hadKeyboardEvent = true;
      }
      /**
       * If at any point a user clicks with a pointing device, ensure that we change
       * the modality away from keyboard.
       * This avoids the situation where a user presses a key on an already focused
       * element, and then clicks on a different element, focusing it with a
       * pointing device, while we still think we're in keyboard modality.
       * @param {Event} e
       */


      function onPointerDown(e) {
        hadKeyboardEvent = false;
      }
      /**
       * On `focus`, add the `focus-visible` class to the target if:
       * - the target received focus as a result of keyboard navigation, or
       * - the event target is an element that will likely require interaction
       *   via the keyboard (e.g. a text box)
       * @param {Event} e
       */


      function onFocus(e) {
        // Prevent IE from focusing the document or HTML element.
        if (!isValidFocusTarget(e.target)) {
          return;
        }

        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
          addFocusVisibleClass(e.target);
        }
      }
      /**
       * On `blur`, remove the `focus-visible` class from the target.
       * @param {Event} e
       */


      function onBlur(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }

        if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
          // To detect a tab/window switch, we look for a blur event followed
          // rapidly by a visibility change.
          // If we don't see a visibility change within 100ms, it's probably a
          // regular focus change.
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e.target);
        }
      }
      /**
       * If the user changes tabs, keep track of whether or not the previously
       * focused element had .focus-visible.
       * @param {Event} e
       */


      function onVisibilityChange(e) {
        if (document.visibilityState === 'hidden') {
          // If the tab becomes active again, the browser will handle calling focus
          // on the element (Safari actually calls it twice).
          // If this tab change caused a blur on an element with focus-visible,
          // re-apply the class when the user switches back to the tab.
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }

          addInitialPointerMoveListeners();
        }
      }
      /**
       * Add a group of listeners to detect usage of any pointing devices.
       * These listeners will be added when the polyfill first loads, and anytime
       * the window is blurred, so that they are active when the window regains
       * focus.
       */


      function addInitialPointerMoveListeners() {
        document.addEventListener('mousemove', onInitialPointerMove);
        document.addEventListener('mousedown', onInitialPointerMove);
        document.addEventListener('mouseup', onInitialPointerMove);
        document.addEventListener('pointermove', onInitialPointerMove);
        document.addEventListener('pointerdown', onInitialPointerMove);
        document.addEventListener('pointerup', onInitialPointerMove);
        document.addEventListener('touchmove', onInitialPointerMove);
        document.addEventListener('touchstart', onInitialPointerMove);
        document.addEventListener('touchend', onInitialPointerMove);
      }

      function removeInitialPointerMoveListeners() {
        document.removeEventListener('mousemove', onInitialPointerMove);
        document.removeEventListener('mousedown', onInitialPointerMove);
        document.removeEventListener('mouseup', onInitialPointerMove);
        document.removeEventListener('pointermove', onInitialPointerMove);
        document.removeEventListener('pointerdown', onInitialPointerMove);
        document.removeEventListener('pointerup', onInitialPointerMove);
        document.removeEventListener('touchmove', onInitialPointerMove);
        document.removeEventListener('touchstart', onInitialPointerMove);
        document.removeEventListener('touchend', onInitialPointerMove);
      }
      /**
       * When the polfyill first loads, assume the user is in keyboard modality.
       * If any event is received from a pointing device (e.g. mouse, pointer,
       * touch), turn off keyboard modality.
       * This accounts for situations where focus enters the page from the URL bar.
       * @param {Event} e
       */


      function onInitialPointerMove(e) {
        // Work around a Safari quirk that fires a mousemove on <html> whenever the
        // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
        if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
          return;
        }

        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      } // For some kinds of state, we are interested in changes at the global scope
      // only. For example, global pointer input, global key presses and global
      // visibility change should affect the state at every scope:


      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('mousedown', onPointerDown, true);
      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('touchstart', onPointerDown, true);
      document.addEventListener('visibilitychange', onVisibilityChange, true);
      addInitialPointerMoveListeners(); // For focus and blur, we specifically care about state changes in the local
      // scope. This is because focus / blur events that originate from within a
      // shadow root are not re-dispatched from the host element if it was already
      // the active element in its own scope:

      scope.addEventListener('focus', onFocus, true);
      scope.addEventListener('blur', onBlur, true); // We detect that a node is a ShadowRoot by ensuring that it is a
      // DocumentFragment and also has a host property. This check covers native
      // implementation and polyfill implementation transparently. If we only cared
      // about the native implementation, we could just check if the scope was
      // an instance of a ShadowRoot.

      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add('js-focus-visible');
        document.documentElement.setAttribute('data-js-focus-visible', '');
      }
    } // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199


    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Make the polyfill helper globally available. This can be used as a signal
      // to interested libraries that wish to coordinate with the polyfill for e.g.,
      // applying the polyfill to a shadow root:
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill; // Notify interested libraries of the polyfill's presence, in case the
      // polyfill was loaded lazily:

      var event;

      try {
        event = new CustomEvent('focus-visible-polyfill-ready');
      } catch (error) {
        // IE11 does not support using CustomEvent as a constructor directly:
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
      }

      window.dispatchEvent(event);
    }

    if (typeof document !== 'undefined') {
      // Apply the polyfill to the global document, so that no JavaScript
      // coordination is required to use the polyfill in the top-level document:
      applyFocusVisiblePolyfill(document);
    }
  });
});
var useNewScrollPosition;

useNewScrollPosition = function useNewScrollPosition(mode, itemWidth) {
  var ref = useState(0);
  var newOffset = ref[0];
  var setNewOffset = ref[1];
  var computeNewOffset = useMemo(function () {
    return function (parent, scroll) {
      var clientWidth = parent.clientWidth;
      var scrollLeft = parent.scrollLeft;
      var scrollTop = parent.scrollTop;
      var clientHeight = parent.clientHeight;
      var timelinePointOffset = scroll.timelinePointOffset;
      var timelinePointWidth = scroll.timelinePointWidth;
      var timelineContentHeight = scroll.timelineContentHeight;
      var timelineContentOffset = scroll.timelineContentOffset;

      if (!timelinePointOffset) {
        return;
      }

      if (mode === 'HORIZONTAL' && itemWidth && timelinePointWidth) {
        var contrRight = scrollLeft + clientWidth;
        var circRight = timelinePointOffset + timelinePointWidth;
        var isVisible = timelinePointOffset >= scrollLeft && circRight <= contrRight;
        var isPartiallyVisible = timelinePointOffset < scrollLeft && circRight > scrollLeft || circRight > contrRight && timelinePointOffset < contrRight;
        var leftGap = timelinePointOffset - scrollLeft;
        var rightGap = contrRight - timelinePointOffset;

        if (!(isVisible || isPartiallyVisible)) {
          setNewOffset(timelinePointOffset - itemWidth);
        } else if (leftGap <= itemWidth && leftGap >= 0) {
          setNewOffset(timelinePointOffset - itemWidth);
        } else if (rightGap <= itemWidth && rightGap >= 0) {
          setNewOffset(timelinePointOffset - itemWidth);
        }
      } else if (mode === 'VERTICAL' || mode === 'VERTICAL_ALTERNATING') {
        if (!timelineContentOffset || !timelineContentHeight) {
          return;
        }

        var contrBottom = scrollTop + clientHeight;
        var circBottom = timelineContentOffset + timelineContentHeight;
        var isVisible$1 = timelineContentOffset >= scrollTop && circBottom <= contrBottom;
        var isPartiallyVisible$1 = timelineContentOffset < scrollTop && circBottom > scrollTop || circBottom > contrBottom && timelineContentOffset < contrBottom;
        var nOffset = timelineContentOffset - timelineContentHeight;
        var notVisible = !isVisible$1 || isPartiallyVisible$1;

        if (notVisible && nOffset + timelineContentHeight < contrBottom) {
          setNewOffset(nOffset + Math.round(timelineContentHeight / 2));
        } else if (notVisible) {
          setNewOffset(nOffset);
        }
      }
    };
  }, [mode, itemWidth]);
  return [newOffset, computeNewOffset];
};

var useNewScrollPosition$1 = useNewScrollPosition;

var ChevronLeft = function ChevronLeft() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-left"
  }, React.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }));
};

var ChevronRightIcon = function ChevronRightIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-right"
  }, React.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
};

var ChevronLeft$1 = function ChevronLeft$1() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-left"
  }, React.createElement("polyline", {
    points: "11 17 6 12 11 7"
  }), React.createElement("polyline", {
    points: "18 17 13 12 18 7"
  }));
};

var ChevronRightIcon$1 = function ChevronRightIcon$1() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-right"
  }, React.createElement("polyline", {
    points: "13 17 18 12 13 7"
  }), React.createElement("polyline", {
    points: "6 17 11 12 6 7"
  }));
};

var ReplayIcon = function ReplayIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("polygon", {
    points: "5 3 19 12 5 21 5 3"
  }));
};

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      var arguments$1 = arguments;

      for (var i = 1; i < arguments.length; i++) {
        var source = arguments$1[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

function _extends() {
  _extends = Object.assign || function (target) {
    var arguments$1 = arguments;

    for (var i = 1; i < arguments.length; i++) {
      var source = arguments$1[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe


function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        before = _this.prepend ? _this.container.firstChild : _this.before;
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }

      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var c = "comm";
var n = "rule";
var t = "decl";
var i = "@import";
var p = "@keyframes";
var k = Math.abs;
var d = String.fromCharCode;

function m(e, r) {
  return (((r << 2 ^ z(e, 0)) << 2 ^ z(e, 1)) << 2 ^ z(e, 2)) << 2 ^ z(e, 3);
}

function g(e) {
  return e.trim();
}

function x(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}

function y(e, r, a) {
  return e.replace(r, a);
}

function j(e, r) {
  return e.indexOf(r);
}

function z(e, r) {
  return e.charCodeAt(r) | 0;
}

function C(e, r, a) {
  return e.slice(r, a);
}

function A(e) {
  return e.length;
}

function M(e) {
  return e.length;
}

function O(e, r) {
  return r.push(e), e;
}

function S(e, r) {
  return e.map(r).join("");
}

var q = 1;
var B = 1;
var D = 0;
var E = 0;
var F = 0;
var G = "";

function H(e, r, a, c, n, t, s) {
  return {
    value: e,
    root: r,
    parent: a,
    type: c,
    props: n,
    children: t,
    line: q,
    column: B,
    length: s,
    return: ""
  };
}

function I(e, r, a) {
  return H(e, r.root, r.parent, a, r.props, r.children, 0);
}

function J() {
  return F;
}

function K() {
  F = E < D ? z(G, E++) : 0;

  if (B++, F === 10) {
    B = 1, q++;
  }

  return F;
}

function L() {
  return z(G, E);
}

function N() {
  return E;
}

function P(e, r) {
  return C(G, e, r);
}

function Q(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;

    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;

    case 58:
      return 3;

    case 34:
    case 39:
    case 40:
    case 91:
      return 2;

    case 41:
    case 93:
      return 1;
  }

  return 0;
}

function R(e) {
  return q = B = 1, D = A(G = e), E = 0, [];
}

function T(e) {
  return G = "", e;
}

function U(e) {
  return g(P(E - 1, Y(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}

function W(e) {
  while (F = L()) {
    if (F < 33) {
      K();
    } else {
      break;
    }
  }

  return Q(e) > 2 || Q(F) > 3 ? "" : " ";
}

function Y(e) {
  while (K()) {
    switch (F) {
      case e:
        return E;

      case 34:
      case 39:
        return Y(e === 34 || e === 39 ? e : F);

      case 40:
        if (e === 41) {
          Y(e);
        }

        break;

      case 92:
        K();
        break;
    }
  }

  return E;
}

function Z(e, r) {
  while (K()) {
    if (e + F === 47 + 10) {
      break;
    } else if (e + F === 42 + 42 && L() === 47) {
      break;
    }
  }

  return "/*" + P(r, E - 1) + "*" + d(e === 47 ? e : K());
}

function _(e) {
  while (!Q(L())) {
    K();
  }

  return P(e, E);
}

function ee(e) {
  return T(re("", null, null, null, [""], e = R(e), 0, [0], e));
}

function re(e, r, a, c, n, t, s, u, i) {
  var f = 0;
  var o = 0;
  var l = s;
  var v = 0;
  var h = 0;
  var p = 0;
  var w = 1;
  var b = 1;
  var $ = 1;
  var k = 0;
  var m = "";
  var g = n;
  var x = t;
  var j = c;
  var z = m;

  while (b) {
    switch (p = k, k = K()) {
      case 34:
      case 39:
      case 91:
      case 40:
        z += U(k);
        break;

      case 9:
      case 10:
      case 13:
      case 32:
        z += W(p);
        break;

      case 47:
        switch (L()) {
          case 42:
          case 47:
            O(ce(Z(K(), N()), r, a), i);
            break;

          default:
            z += "/";
        }

        break;

      case 123 * w:
        u[f++] = A(z) * $;

      case 125 * w:
      case 59:
      case 0:
        switch (k) {
          case 0:
          case 125:
            b = 0;

          case 59 + o:
            if (h > 0) {
              O(h > 32 ? ne(z + ";", c, a, l - 1) : ne(y(z, " ", "") + ";", c, a, l - 2), i);
            }

            break;

          case 59:
            z += ";";

          default:
            O(j = ae(z, r, a, f, o, n, u, m, g = [], x = [], l), t);

            if (k === 123) {
              if (o === 0) {
                re(z, r, j, j, g, t, l, u, x);
              } else {
                switch (v) {
                  case 100:
                  case 109:
                  case 115:
                    re(e, j, j, c && O(ae(e, j, j, 0, 0, n, u, m, n, g = [], l), x), n, x, l, u, c ? g : x);
                    break;

                  default:
                    re(z, j, j, j, [""], x, l, u, x);
                }
              }
            }

        }

        f = o = h = 0, w = $ = 1, m = z = "", l = s;
        break;

      case 58:
        l = 1 + A(z), h = p;

      default:
        switch (z += d(k), k * w) {
          case 38:
            $ = o > 0 ? 1 : (z += "\f", -1);
            break;

          case 44:
            u[f++] = (A(z) - 1) * $, $ = 1;
            break;

          case 64:
            if (L() === 45) {
              z += U(K());
            }

            v = L(), o = A(m = z += _(N())), k++;
            break;

          case 45:
            if (p === 45 && A(z) == 2) {
              w = 0;
            }

        }

    }
  }

  return t;
}

function ae(e, r, a, c, t, s, u, i, f, o, l) {
  var v = t - 1;
  var h = t === 0 ? s : [""];
  var p = M(h);

  for (var w = 0, b = 0, $ = 0; w < c; ++w) {
    for (var d = 0, m = C(e, v + 1, v = k(b = u[w])), x = e; d < p; ++d) {
      if (x = g(b > 0 ? h[d] + " " + m : y(m, /&\f/g, h[d]))) {
        f[$++] = x;
      }
    }
  }

  return H(e, r, a, t === 0 ? n : i, f, o, l);
}

function ce(e, r, a) {
  return H(e, r, a, c, d(J()), C(e, 2, -2), 0);
}

function ne(e, r, a, c) {
  return H(e, r, a, t, C(e, 0, c), C(e, c + 1, -1), c);
}

function te(c, n) {
  switch (m(c, n)) {
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return a + c + c;

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return a + c + r + c + e + c + c;

    case 6828:
    case 4268:
      return a + c + e + c + c;

    case 6165:
      return a + c + e + "flex-" + c + c;

    case 5187:
      return a + c + y(c, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + c;

    case 5443:
      return a + c + e + "flex-item-" + y(c, /flex-|-self/, "") + c;

    case 4675:
      return a + c + e + "flex-line-pack" + y(c, /align-content|flex-|-self/, "") + c;

    case 5548:
      return a + c + e + y(c, "shrink", "negative") + c;

    case 5292:
      return a + c + e + y(c, "basis", "preferred-size") + c;

    case 6060:
      return a + "box-" + y(c, "-grow", "") + a + c + e + y(c, "grow", "positive") + c;

    case 4554:
      return a + y(c, /([^-])(transform)/g, "$1" + a + "$2") + c;

    case 6187:
      return y(y(y(c, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), c, "") + c;

    case 5495:
    case 3959:
      return y(c, /(image-set\([^]*)/, a + "$1" + "$`$1");

    case 4968:
      return y(y(c, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + c + c;

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return y(c, /(.+)-inline(.+)/, a + "$1$2") + c;

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (A(c) - 1 - n > 6) {
        switch (z(c, n + 1)) {
          case 109:
            return y(c, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + "$2-$3") + c;

          case 102:
            return y(c, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + "$3") + c;

          case 115:
            return te(y(c, "stretch", "fill-available"), n) + c;
        }
      }

      break;

    case 4949:
      if (z(c, n + 1) !== 115) {
        break;
      }

    case 6444:
      switch (z(c, A(c) - 3 - (~j(c, "!important") && 10))) {
        case 107:
        case 111:
          return y(c, c, a + c) + c;

        case 101:
          return y(c, /(.+:)([^;!]+)(;|!.+)?/, "$1" + a + (z(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + c;
      }

      break;

    case 5936:
      switch (z(c, n + 11)) {
        case 114:
          return a + c + e + y(c, /[svh]\w+-[tblr]{2}/, "tb") + c;

        case 108:
          return a + c + e + y(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;

        case 45:
          return a + c + e + y(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
      }

      return a + c + e + c + c;
  }

  return c;
}

function se(e, r) {
  var a = "";
  var c = M(e);

  for (var n = 0; n < c; n++) {
    a += r(e[n], n, e, r) || "";
  }

  return a;
}

function ue(e, r, a, s) {
  switch (e.type) {
    case i:
    case t:
      return e.return = e.return || e.value;

    case c:
      return "";

    case n:
      e.value = e.props.join(",");
  }

  return A(a = se(e.children, s)) ? e.return = e.value + "{" + a + "}" : "";
}

function ie(e) {
  var r = M(e);
  return function (a, c, n, t) {
    var s = "";

    for (var u = 0; u < r; u++) {
      s += e[u](a, c, n, t) || "";
    }

    return s;
  };
}

function fe(e) {
  return function (r) {
    if (!r.root) {
      if (r = r.return) {
        e(r);
      }
    }
  };
}

function oe(c, s, u, i) {
  if (!c.return) {
    switch (c.type) {
      case t:
        c.return = te(c.value, c.length);
        break;

      case p:
        return se([I(y(c.value, "@", "@" + a), c, "")], i);

      case n:
        if (c.length) {
          return S(c.props, function (n) {
            switch (x(n, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return se([I(y(n, /:(read-\w+)/, ":" + r + "$1"), c, "")], i);

              case "::placeholder":
                return se([I(y(n, /:(plac\w+)/, ":" + a + "input-$1"), c, ""), I(y(n, /:(plac\w+)/, ":" + r + "$1"), c, ""), I(y(n, /:(plac\w+)/, e + "input-$1"), c, "")], i);
            }

            return "";
          });
        }

    }
  }
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (Q(character)) {
      case 0:
        // &\f
        if (character === 38 && L() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += _(E - 1);
        break;

      case 2:
        parsed[index] += U(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = L() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += d(character);
    }
  } while (character = K());

  return parsed;
};

var getRules = function getRules(value, points) {
  return T(toRules(R(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();

var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
  !element.length) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};

var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') {
      return;
    }

    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var isBrowser = typeof document !== 'undefined';
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [oe];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to

    Array.prototype.forEach.call(ssrStyles, function (node) {
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  if (isBrowser) {
    container = options.container || document.head;
    Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      if (attrib[0] !== key) {
        return;
      } // $FlowFixMe


      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser) {
    var currentSheet;
    var finalizingPlugins = [ue, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== c) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : fe(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = ie(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return se(ee(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [ue];

    var _serializer = ie(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return se(ee(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol.for,
    c$1 = b ? Symbol.for("react.element") : 60103,
    d$1 = b ? Symbol.for("react.portal") : 60106,
    e$1 = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g$1 = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k$1 = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m$1 = b ? Symbol.for("react.concurrent_mode") : 60111,
    n$1 = b ? Symbol.for("react.forward_ref") : 60112,
    p$1 = b ? Symbol.for("react.suspense") : 60113,
    q$1 = b ? Symbol.for("react.suspense_list") : 60120,
    r$1 = b ? Symbol.for("react.memo") : 60115,
    t$1 = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x$1 = b ? Symbol.for("react.responder") : 60118,
    y$1 = b ? Symbol.for("react.scope") : 60119;

function z$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l:
          case m$1:
          case e$1:
          case g$1:
          case f:
          case p$1:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$1:
              case t$1:
              case r$1:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d$1:
        return u;
    }
  }
}

function A$1(a) {
  return z$1(a) === m$1;
}

var AsyncMode = l;
var ConcurrentMode = m$1;
var ContextConsumer = k$1;
var ContextProvider = h;
var Element = c$1;
var ForwardRef = n$1;
var Fragment = e$1;
var Lazy = t$1;
var Memo = r$1;
var Portal = d$1;
var Profiler = g$1;
var StrictMode = f;
var Suspense = p$1;

var isAsyncMode = function isAsyncMode(a) {
  return A$1(a) || z$1(a) === l;
};

var isConcurrentMode = A$1;

var isContextConsumer = function isContextConsumer(a) {
  return z$1(a) === k$1;
};

var isContextProvider = function isContextProvider(a) {
  return z$1(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1;
};

var isForwardRef = function isForwardRef(a) {
  return z$1(a) === n$1;
};

var isFragment = function isFragment(a) {
  return z$1(a) === e$1;
};

var isLazy = function isLazy(a) {
  return z$1(a) === t$1;
};

var isMemo = function isMemo(a) {
  return z$1(a) === r$1;
};

var isPortal = function isPortal(a) {
  return z$1(a) === d$1;
};

var isProfiler = function isProfiler(a) {
  return z$1(a) === g$1;
};

var isStrictMode = function isStrictMode(a) {
  return z$1(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z$1(a) === p$1;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v);
};

var typeOf = z$1;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser$1 = typeof document !== 'undefined';

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}

var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86


function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;

var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$2 = typeof document !== 'undefined';
var hasOwnProperty = Object.prototype.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$2) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /*#__PURE__*/createContext({});
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var Emotion = withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, typeof cssProp === 'function' || Array.isArray(cssProp) ? useContext(ThemeContext) : undefined);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/createElement(type, newProps);

  if (!isBrowser$2 && rules !== undefined) {
    var _ref;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/createElement(Fragment$1, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }

  return ele;
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var pkg = {
  name: "@emotion/react",
  version: "11.0.0",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  types: "types/index.d.ts",
  files: ["src", "dist", "jsx-runtime", "jsx-dev-runtime", "types/*.d.ts", "macro.js", "macro.d.ts", "macro.js.flow"],
  author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.7.2",
    "@emotion/cache": "^11.0.0",
    "@emotion/serialize": "^1.0.0",
    "@emotion/sheet": "^1.0.0",
    "@emotion/utils": "^1.0.0",
    "@emotion/weak-memoize": "^0.2.5",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    "@babel/core": "^7.0.0",
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@babel/core": {
      optional: true
    },
    "@types/react": {
      optional: true
    }
  },
  devDependencies: {
    "@babel/core": "^7.7.2",
    "@emotion/css": "11.0.0",
    "@emotion/css-prettifier": "1.0.0",
    "@emotion/server": "11.0.0",
    "@emotion/styled": "11.0.0",
    "@types/react": "^16.9.11",
    dtslint: "^0.3.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1"
  },
  repository: "https://github.com/emotion-js/emotion/tree/master/packages/core",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: ["./index.js", "./jsx-runtime.js", "./jsx-dev-runtime.js"],
    umdName: "emotionReact"
  }
};

function css() {
  var arguments$1 = arguments;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments$1[_key];
  }

  return serializeStyles(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

if (process.env.NODE_ENV !== 'production') {
  var isBrowser$3 = typeof document !== 'undefined'; // #1727 for some reason Jest evaluates modules twice if some consuming module gets mocked with jest.mock

  var isJest = typeof jest !== 'undefined';

  if (isBrowser$3 && !isJest) {
    var globalContext = isBrowser$3 ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser$4 = typeof document !== 'undefined';

var createStyled = function createStyled(tag, options) {
  if (process.env.NODE_ENV !== 'production') {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (process.env.NODE_ENV !== 'production' && args[0][0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (process.env.NODE_ENV !== 'production' && args[0][i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, cache, ref) {
      var finalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = useContext(ThemeContext);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      var rules = insertStyles(cache, serialized, typeof finalTag === 'string');
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') {
          continue;
        }

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      var ele = /*#__PURE__*/createElement(finalTag, newProps);

      if (!isBrowser$4 && rules !== undefined) {
        var _ref;

        var serializedNames = serialized.name;
        var next = serialized.next;

        while (next !== undefined) {
          serializedNames += ' ' + next.name;
          next = next.next;
        }

        return /*#__PURE__*/createElement(Fragment$1, null, /*#__PURE__*/createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
          __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
      }

      return ele;
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && process.env.NODE_ENV !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends({}, options, {}, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});
var TimelineNavWrapper = newStyled.ul(_templateObject());
var TimelineNavItem = newStyled.li(_templateObject2(), function (p) {
  return p.disable ? 'pointer-events: none; filter: opacity(0.7)' : '';
});
var TimelineNavButton = newStyled.button(_templateObject3(), function (p) {
  return p.theme.primary;
}, function (p) {
  if (p.rotate === 'TRUE') {
    return "rotate(90deg)";
  }
}, function (p) {
  return p.rotate === 'TRUE' ? 'rotate(90deg)' : '';
});
var TimelineControlContainer = newStyled.div(_templateObject4(), function (p) {
  return p.slideShowActive ? 'hidden' : 'visible';
});
var ControlButton = newStyled.button(_templateObject5(), function (p) {
  return p.theme.primary;
});
var MediaToggle = newStyled(ControlButton)(_templateObject6());
var ReplayWrapper = newStyled(ControlButton)(_templateObject7());
var TimelineControl = React.memo(function (ref) {
  var onNext = ref.onNext;
  var onPrevious = ref.onPrevious;
  var onFirst = ref.onFirst;
  var onLast = ref.onLast;
  var disableLeft = ref.disableLeft;
  var disableRight = ref.disableRight;
  var theme = ref.theme;
  var slideShowRunning = ref.slideShowRunning;
  var onReplay = ref.onReplay;
  var slideShowEnabled = ref.slideShowEnabled;
  var mode = ref.mode;
  var rotate = useMemo(function () {
    return mode !== 'HORIZONTAL';
  }, [mode]);
  return React.createElement(TimelineControlContainer, {
    slideShowActive: slideShowRunning
  }, React.createElement(TimelineNavWrapper, {
    className: "timeline-controls"
  }, React.createElement(TimelineNavItem, {
    disable: disableLeft
  }, React.createElement(TimelineNavButton, {
    mode: mode,
    theme: theme,
    onClick: onFirst,
    title: "Go to First",
    "aria-label": "first",
    "aria-disabled": disableLeft,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: !disableLeft ? 0 : -1,
    rotate: rotate ? 'TRUE' : 'FALSE'
  }, React.createElement(ChevronLeft$1, null))), React.createElement(TimelineNavItem, {
    disable: disableLeft
  }, React.createElement(TimelineNavButton, {
    mode: mode,
    theme: theme,
    onClick: onPrevious,
    title: "Previous",
    "aria-label": "previous",
    "aria-disabled": disableLeft,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: !disableLeft ? 0 : -1,
    rotate: rotate ? 'TRUE' : 'FALSE'
  }, React.createElement(ChevronLeft, null))), React.createElement(TimelineNavItem, {
    disable: disableRight
  }, React.createElement(TimelineNavButton, {
    mode: mode,
    theme: theme,
    onClick: onNext,
    title: "Next",
    "aria-label": "next",
    "aria-disabled": disableRight,
    "aria-controls": "timeline-main-wrapper",
    rotate: rotate ? 'TRUE' : 'FALSE',
    tabIndex: !disableRight ? 0 : -1
  }, React.createElement(ChevronRightIcon, null))), React.createElement(TimelineNavItem, {
    disable: disableRight
  }, React.createElement(TimelineNavButton, {
    mode: mode,
    theme: theme,
    onClick: onLast,
    title: "Go to Last",
    "aria-label": "last",
    "aria-disabled": disableRight,
    "aria-controls": "timeline-main-wrapper",
    tabIndex: !disableRight ? 0 : -1,
    rotate: rotate ? 'TRUE' : 'FALSE'
  }, React.createElement(ChevronRightIcon$1, null))), React.createElement(TimelineNavItem, null, slideShowEnabled && React.createElement(TimelineNavButton, {
    theme: theme,
    onClick: onReplay,
    title: "Play Slideshow",
    tabIndex: 0,
    "aria-controls": "timeline-main-wrapper",
    "aria-label": "Play Slideshow"
  }, React.createElement(ReplayIcon, null)))));
});
TimelineControl.displayName = 'Timeline Control';
var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var arguments$1 = arguments;
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments$1[i];

        if (!arg) {
          continue;
        }

        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var TimelineItemContentWrapper = newStyled.section(_templateObject8(), function (p) {
  return p.mode !== 'VERTICAL_ALTERNATING' ? '1em 0' : '';
}, function (p) {
  var _p$theme;

  return (_p$theme = p.theme) === null || _p$theme === void 0 ? void 0 : _p$theme.primary;
});
var TimelineCardHeader = newStyled.header(_templateObject9());
var TimelineContentSubTitle = newStyled.p(_templateObject10(), function (p) {
  return p.theme.primary;
});
var TimelinecardTitle = newStyled.p(_templateObject11(), function (p) {
  return p.theme.primary;
});
var TimelineContentDetails = newStyled.p(_templateObject12());
var TimelineContentDetailsWrapper = newStyled.div(_templateObject13(), function (p) {
  return !p.customContent ? 'max-height: 200px;' : '';
}, function (p) {
  var _p$theme2;

  return (_p$theme2 = p.theme) === null || _p$theme2 === void 0 ? void 0 : _p$theme2.primary;
}, function (p) {
  var _p$theme3;

  return (_p$theme3 = p.theme) === null || _p$theme3 === void 0 ? void 0 : _p$theme3.primary;
}, function (p) {
  var _p$theme4;

  return (_p$theme4 = p.theme) === null || _p$theme4 === void 0 ? void 0 : _p$theme4.primary;
});
var ShowMore = newStyled.span(_templateObject14(), function (p) {
  return p.show ? 'flex' : 'none';
}, function (p) {
  return p.theme.primary;
});

var slideAnimation = function slideAnimation(start, end) {
  return keyframes(_templateObject15(), start, end);
};

var SlideShowProgressBar = newStyled.span(_templateObject16(), function (p) {
  return p.color;
}, function (p) {
  if (!p.paused && p.startWidth && p.startWidth > 0) {
    return css(_templateObject17(), slideAnimation(p.startWidth, 0), p.duration);
  } else {
    return css(_templateObject18(), p.startWidth);
  }
});
var ChevronIconWrapper = newStyled.span(_templateObject19(), function (p) {
  return p.collapsed ? "\n      transform: rotate(90deg);\n  " : "transform: rotate(-90deg)";
});
var MemoTitle = React.memo(function (ref) {
  var title = ref.title;
  var theme = ref.theme;
  var color = ref.color;
  var dir = ref.dir;
  var active = ref.active;
  return title && theme ? React.createElement(TimelinecardTitle, {
    className: active ? 'active card-title' : 'card-title',
    theme: theme,
    style: {
      color: color
    },
    dir: dir
  }, title) : null;
}, function () {
  return true;
});
MemoTitle.displayName = 'Timeline Title';
var MemoSubTitle = React.memo(function (ref) {
  var content = ref.content;
  var color = ref.color;
  var dir = ref.dir;
  var theme = ref.theme;
  return content ? React.createElement(TimelineContentSubTitle, {
    style: {
      color: color
    },
    dir: dir,
    theme: theme,
    className: "card-sub-title"
  }, content) : null;
}, function () {
  return true;
});
MemoSubTitle.displayName = 'Timeline Content';
var MediaWrapper = newStyled.div(_templateObject20(), function (p) {
  return p.cardHeight ? "min-height: ".concat(p.cardHeight, "px;") : '';
}, function (p) {
  var _p$theme;

  return p.active ? "rgba(".concat((_p$theme = p.theme) === null || _p$theme === void 0 ? void 0 : _p$theme.secondary, ", 0.35)") : '';
}, function (p) {
  return !p.active && p.slideShowActive ? 'none' : '';
}, function (p) {
  if (p.mode === 'HORIZONTAL') {
    return "\n        justify-content: flex-start;\n      ";
  } else {
    if (p.dir === 'left') {
      return "\n        justify-content: flex-start;\n      ";
    } else {
      return "\n        justify-content: flex-end;\n      ";
    }
  }
});
var CardImage = newStyled.img(_templateObject21(), function (p) {
  return p.visible ? 'visible' : 'hidden';
});
var CardVideo = newStyled.video(_templateObject22());
var MediaDetailsWrapper = newStyled.div(_templateObject23(), function (p) {
  switch (p.mode) {
    case 'HORIZONTAL':
      return '100%';

    case 'VERTICAL':
      return '100%';

    case 'VERTICAL_ALTERNATING':
      return '100%';
  }
});
var ErrorMessage = newStyled.span(_templateObject24());

var CardMedia = function CardMedia(ref) {
  var active = ref.active;
  var id = ref.id;
  var mode = ref.mode;
  var onMediaStateChange = ref.onMediaStateChange;
  var theme = ref.theme;
  var title = ref.title;
  var content = ref.content;
  var media = ref.media;
  var slideshowActive = ref.slideshowActive;
  var hideMedia = ref.hideMedia;
  if (hideMedia === void 0) hideMedia = false;
  var cardHeight = ref.cardHeight;
  var videoRef = useRef(null);
  var ref$1 = useState(false);
  var loadFailed = ref$1[0];
  var setLoadFailed = ref$1[1];
  useEffect(function () {
    if (!videoRef) {
      return;
    }

    if (active) {
      // play the video when active
      videoRef.current && videoRef.current.play();
    } else {
      // pause the video when not active
      videoRef.current && videoRef.current.pause();
    }
  }, [active]);
  var ref$2 = useState(false);
  var mediaLoaded = ref$2[0];
  var setMediaLoaded = ref$2[1];
  var handleMediaLoaded = useCallback(function () {
    setMediaLoaded(true);
  }, []);
  var handleError = useCallback(function () {
    setLoadFailed(true);
    onMediaStateChange({
      id: id,
      paused: false,
      playing: false
    });
  }, []);
  var ErrorMessageMem = React.memo(function (ref) {
    var message = ref.message;
    return React.createElement(ErrorMessage, null, message);
  });
  var Video = useMemo(function () {
    return React.createElement(CardVideo, {
      controls: true,
      autoPlay: active,
      ref: videoRef,
      onLoadedData: handleMediaLoaded,
      onPlay: function onPlay() {
        return onMediaStateChange({
          id: id,
          paused: false,
          playing: true
        });
      },
      onPause: function onPause() {
        return onMediaStateChange({
          id: id,
          paused: true,
          playing: false
        });
      },
      onEnded: function onEnded() {
        return onMediaStateChange({
          id: id,
          paused: false,
          playing: false
        });
      },
      onError: handleError
    }, React.createElement("source", {
      src: media.source.url
    }));
  }, [active]);
  var Image = useMemo(function () {
    return React.createElement(CardImage, {
      src: media.source.url,
      mode: mode,
      onLoad: handleMediaLoaded,
      onError: handleError,
      visible: mediaLoaded,
      active: active,
      alt: media.name
    });
  }, [active, mediaLoaded]);
  ErrorMessageMem.displayName = 'Error Message';
  return React.createElement(React.Fragment, null, React.createElement(MediaWrapper, {
    theme: theme,
    active: active,
    mode: mode,
    slideShowActive: slideshowActive,
    className: "card-media-wrapper",
    cardHeight: cardHeight
  }, media.type === 'VIDEO' && (!loadFailed ? Video : React.createElement(ErrorMessageMem, {
    message: "Failed to load the video"
  })), media.type === 'IMAGE' && (!loadFailed ? Image : React.createElement(ErrorMessageMem, {
    message: "Failed to load the image."
  }))), React.createElement(MediaDetailsWrapper, {
    mode: mode
  }, React.createElement(MemoTitle, {
    title: title,
    theme: theme,
    active: active
  }), React.createElement(MemoSubTitle, {
    content: content
  })));
};

var TimelineCardContent = React.memo(function (ref) {
  var active = ref.active;
  var cardHeight = ref.cardHeight;
  var content = ref.content;
  var detailedText = ref.detailedText;
  var id = ref.id;
  var media = ref.media;
  var mode = ref.mode;
  var onShowMore = ref.onShowMore;
  var slideShowActive = ref.slideShowActive;
  var slideItemDuration = ref.slideItemDuration;
  var onElapsed = ref.onElapsed;
  var theme = ref.theme;
  var title = ref.title;
  var _onClick = ref.onClick;
  var customContent = ref.customContent;
  var hasFocus = ref.hasFocus;
  var ref$1 = useState(false);
  var showMore = ref$1[0];
  var setShowMore = ref$1[1];
  var detailsRef = useRef(null);
  var containerRef = useRef(null);
  var progressRef = useRef(null);
  var containerWidth = useRef(0);
  var slideShowElapsed = useRef(0);
  var timerRef = useRef(0);
  var startTime = useRef();
  var ref$2 = useState(false);
  var paused = ref$2[0];
  var setPaused = ref$2[1]; // const [elapsed, setElapsed] = useState(0);

  var ref$3 = useState(0);
  var remainInterval = ref$3[0];
  var setRemainInterval = ref$3[1];
  var ref$4 = useState(0);
  var startWidth = ref$4[0];
  var setStartWidth = ref$4[1];
  var canShowProgressBar = useMemo(function () {
    var canShow = active && slideShowActive;

    if (media) {
      return canShow && media.type !== 'VIDEO';
    } else {
      return canShow;
    }
  }, [active, slideShowActive]);
  var canShowMore = useMemo(function () {
    return !!detailedText;
  }, [detailedText]);
  useEffect(function () {
    var detailsEle = detailsRef.current;

    if (detailsEle) {
      detailsEle.scrollTop = 0;
    }
  }, [showMore]);
  useEffect(function () {
    setTimeout(function () {
      if (containerRef.current) {
        containerWidth.current = containerRef.current.clientWidth;
        setStartWidth(containerWidth.current);
      }
    }, 100);
  }, []);
  var setupTimer = useCallback(function (interval) {
    if (!slideItemDuration) {
      return;
    }

    setRemainInterval(interval);
    startTime.current = new Date();
    setPaused(false);
    timerRef.current = window.setTimeout(function () {
      // clear the timer and move to the next card
      window.clearTimeout(timerRef.current);
      setPaused(true);
      setStartWidth(0);
      setRemainInterval(slideItemDuration);
      id && onElapsed && onElapsed(id);
    }, interval);
  }, []); // pause the slide show

  var tryHandlePauseSlideshow = useCallback(function () {
    if (active && slideShowActive) {
      window.clearTimeout(timerRef.current);
      setPaused(true);

      if (startTime.current) {
        var elapsed = +new Date() - +startTime.current;
        slideShowElapsed.current = elapsed;
      }

      if (progressRef.current) {
        setStartWidth(progressRef.current.clientWidth);
      }
    }
  }, [active, slideShowActive]); // resumes the slide show

  var tryHandleResumeSlideshow = useCallback(function () {
    if (active && slideShowActive) {
      if (!slideItemDuration) {
        return;
      }

      var remainingInterval = slideItemDuration - slideShowElapsed.current; // setRemainInterval(remainingInterval);

      setPaused(false);

      if (remainingInterval > 0) {
        setupTimer(remainingInterval);
      }
    }
  }, [active, slideShowActive, slideItemDuration]);
  useEffect(function () {
    if (!slideItemDuration) {
      return;
    } // setup the timer


    if (active && slideShowActive) {
      setStartWidth(containerWidth.current);
      setupTimer(slideItemDuration);
    } // disabled autofocus on active


    if (active && hasFocus) {
      containerRef.current && containerRef.current.focus();
    }
  }, [active, slideShowActive]);
  useEffect(function () {
    if (hasFocus && active) {
      containerRef.current && containerRef.current.focus();
    }
  }, [hasFocus, active]);
  var handleMediaState = useCallback(function (state) {
    if (!slideShowActive) {
      return;
    }

    if (state.playing) {
      tryHandlePauseSlideshow();
    } else if (state.paused) {
      if (paused && id && onElapsed) {
        onElapsed(id);
      }
    }
  }, [paused, slideShowActive]);
  var contentClass = useMemo(function () {
    return classnames(active ? 'timeline-card-content active' : 'timeline-card-content ');
  }, [active]);
  var contentDetailsClass = useMemo(function () {
    return classnames(!showMore && !customContent ? 'show-less card-description' : 'card-description');
  }, [showMore, customContent]);
  var handleExpandDetails = useCallback(function () {
    if (active && paused || !slideShowActive) {
      setShowMore(!showMore);
      onShowMore();
    }
  }, [active, paused, slideShowActive, showMore]);
  return React.createElement(TimelineItemContentWrapper, {
    className: contentClass,
    theme: theme,
    noMedia: !media,
    minHeight: cardHeight,
    mode: mode,
    onClick: function onClick(ev) {
      ev.stopPropagation();

      if (!slideShowActive && _onClick && id) {
        _onClick(id);
      }
    },
    onMouseEnter: tryHandlePauseSlideshow,
    onMouseLeave: tryHandleResumeSlideshow,
    ref: containerRef,
    tabIndex: 0
  }, React.createElement(TimelineCardHeader, null, !media && React.createElement(MemoTitle, {
    title: title,
    theme: theme
  }), !media && React.createElement(MemoSubTitle, {
    content: content,
    theme: theme
  })), media && React.createElement(CardMedia, {
    media: media,
    content: content,
    title: title,
    mode: mode,
    onMediaStateChange: handleMediaState,
    id: id,
    active: active,
    theme: theme,
    slideshowActive: slideShowActive,
    hideMedia: showMore,
    cardHeight: cardHeight
  }), React.createElement(TimelineContentDetailsWrapper, {
    ref: detailsRef,
    className: contentDetailsClass,
    theme: theme,
    "aria-expanded": showMore,
    customContent: !!customContent
  }, customContent ? React.createElement(React.Fragment, null, customContent) : React.createElement(TimelineContentDetails, {
    className: showMore ? 'active' : '',
    ref: detailsRef
  }, detailedText)), detailedText && !customContent && React.createElement(ShowMore, {
    role: "button",
    onClick: handleExpandDetails,
    onKeyPress: useCallback(function (event) {
      if (event.key === 'Enter') {
        handleExpandDetails();
      }
    }, [active, paused, slideShowActive, showMore]),
    className: "show-more",
    show: canShowMore,
    theme: theme,
    tabIndex: 0
  }, React.createElement("span", null, showMore ? 'read less' : 'read more'), React.createElement(ChevronIconWrapper, {
    collapsed: !showMore
  }, React.createElement(ChevronRightIcon, null))), canShowProgressBar && React.createElement(SlideShowProgressBar, {
    startWidth: startWidth,
    paused: paused,
    duration: remainInterval,
    ref: progressRef,
    color: theme && theme.primary
  }));
});
TimelineCardContent.displayName = 'TimelineCardContent';
var TitleWrapper = newStyled.div(_templateObject25(), function (p) {
  return p.hide ? 'hidden' : 'visible';
}, function (p) {
  return p.align;
}, function (p) {
  var _p$theme;

  return (_p$theme = p.theme) === null || _p$theme === void 0 ? void 0 : _p$theme.secondary;
}, function (p) {
  var _p$theme2;

  return (_p$theme2 = p.theme) === null || _p$theme2 === void 0 ? void 0 : _p$theme2.primary;
});

var TimelineItemTitle = function TimelineItemTitle(ref) {
  var title = ref.title;
  var active = ref.active;
  var theme = ref.theme;
  var align = ref.align;
  var titleClass = useMemo(function () {
    return classnames('timeline-item-title', active ? 'active' : '');
  }, [active]);
  return React.createElement(TitleWrapper, {
    className: titleClass,
    theme: theme,
    hide: !title,
    align: align
  }, title);
};

var Wrapper = newStyled.div(_templateObject26());
var Item = newStyled.div(_templateObject27());
var scaleUp = keyframes(_templateObject28());
var scaleDown = keyframes(_templateObject29());
var show = keyframes(_templateObject30());
var CircleWrapper = newStyled.div(_templateObject31());
var Circle = newStyled.div(_templateObject32(), function (p) {
  var _p$theme;

  return (_p$theme = p.theme) === null || _p$theme === void 0 ? void 0 : _p$theme.primary;
}, scaleUp, function (p) {
  return p.theme.secondary;
}, scaleDown);
var TimelineTitleContainer = newStyled.div(_templateObject33());
var TimelineContentContainer = newStyled.div(_templateObject34(), show);

var TimelineCard = function TimelineCard(ref) {
  var active = ref.active;
  var autoScroll = ref.autoScroll;
  var cardHeight = ref.cardHeight;
  var cardDetailedText = ref.cardDetailedText;
  var cardSubtitle = ref.cardSubtitle;
  var cardTitle = ref.cardTitle;
  var id = ref.id;
  var media = ref.media;
  var mode = ref.mode;
  var onClick = ref.onClick;
  var onElapsed = ref.onElapsed;
  var position = ref.position;
  var slideItemDuration = ref.slideItemDuration;
  var slideShowRunning = ref.slideShowRunning;
  var theme = ref.theme;
  var title = ref.title;
  var wrapperId = ref.wrapperId;
  var customContent = ref.customContent;
  var hasFocus = ref.hasFocus;
  var circleRef = useRef(null);
  var wrapperRef = useRef(null);
  var contentRef = useRef(null);

  var handleClick = function handleClick() {
    if (onClick && !slideShowRunning) {
      onClick(id);
    }
  };

  useEffect(function () {
    if (active) {
      var circle = circleRef.current;
      var wrapper = wrapperRef.current;

      if (circle && wrapper) {
        var circleOffsetLeft = circle.offsetLeft;
        var wrapperOffsetLeft = wrapper.offsetLeft;
        autoScroll({
          timelinePointOffset: circleOffsetLeft + wrapperOffsetLeft,
          timelinePointWidth: circle.clientWidth
        });
      }
    }
  }, [active, autoScroll, mode]);
  var handleOnShowMore = useCallback(function () {}, []);
  var modeLower = useMemo(function () {
    return mode === null || mode === void 0 ? void 0 : mode.toLowerCase();
  }, [mode]);
  var containerClass = useMemo(function () {
    return classnames('timeline-horz-card-wrapper', modeLower, position === 'top' ? 'bottom' : 'top');
  }, [mode, position]);
  var titleClass = useMemo(function () {
    return classnames(modeLower, position);
  }, []);
  var circleClass = useMemo(function () {
    return classnames('timeline-circle', modeLower, active ? 'active' : 'in-active');
  }, [active]);
  var timelineContent = useMemo(function () {
    return React.createElement(TimelineContentContainer, {
      className: containerClass,
      ref: contentRef
    }, React.createElement(TimelineCardContent, {
      content: cardSubtitle,
      active: active,
      title: cardTitle,
      detailedText: cardDetailedText,
      onShowMore: handleOnShowMore,
      theme: theme,
      slideShowActive: slideShowRunning,
      media: media,
      mode: mode,
      cardHeight: cardHeight,
      slideItemDuration: slideItemDuration,
      onElapsed: onElapsed,
      id: id,
      customContent: customContent,
      hasFocus: hasFocus
    }));
  }, [active]);

  var showTimelineContent = function showTimelineContent() {
    var ele = document.getElementById(wrapperId);

    if (ele) {
      return ReactDOM.createPortal(timelineContent, ele);
    }
  };

  return React.createElement(Wrapper, {
    ref: wrapperRef,
    className: modeLower,
    "data-testid": "timeline-item"
  }, active && showTimelineContent(), React.createElement(CircleWrapper, null, React.createElement(Circle, {
    className: circleClass,
    onClick: handleClick,
    ref: circleRef,
    "data-testid": "timeline-circle",
    theme: theme,
    "aria-label": title
  })), React.createElement(TimelineTitleContainer, {
    className: titleClass,
    "data-testid": "timeline-title"
  }, React.createElement(TimelineItemTitle, {
    title: title,
    active: active,
    theme: theme
  })));
};

var TimelineHorizontalWrapper = newStyled.ul(_templateObject35());
var TimelineItemWrapper = newStyled.li(_templateObject36(), function (p) {
  return p.width;
});

var TimelineHorizontal = function TimelineHorizontal(ref) {
  var items = ref.items;
  var itemWidth = ref.itemWidth;
  var handleItemClick = ref.handleItemClick;
  var autoScroll = ref.autoScroll;
  var mode = ref.mode;
  var wrapperId = ref.wrapperId;
  var theme = ref.theme;
  var slideShowRunning = ref.slideShowRunning;
  var cardHeight = ref.cardHeight;
  var slideItemDuration = ref.slideItemDuration;
  var onElapsed = ref.onElapsed;
  var children = ref.contentDetailsChildren;
  var hasFocus = ref.hasFocus;
  var wrapperClass = useMemo(function () {
    return classnames(mode.toLowerCase(), 'timeline-horz-container');
  }, [mode]);
  return React.createElement(TimelineHorizontalWrapper, {
    className: wrapperClass,
    "data-testid": "timeline-collection"
  }, items.map(function (item, index) {
    return React.createElement(TimelineItemWrapper, {
      key: item.id,
      width: itemWidth,
      className: classnames(item.visible ? 'visible' : '', 'timeline-horz-item-container')
    }, React.createElement(TimelineCard, Object.assign({}, item, {
      onClick: handleItemClick,
      autoScroll: autoScroll,
      mode: mode,
      wrapperId: wrapperId,
      theme: theme,
      slideShowRunning: slideShowRunning,
      cardHeight: cardHeight,
      slideItemDuration: slideItemDuration,
      onElapsed: onElapsed,
      customContent: children ? children[index] : null,
      hasFocus: hasFocus
    })));
  }));
};

var TimelineVerticalWrapper = newStyled.div(_templateObject37());
var animateVisible = keyframes(_templateObject38());
var VerticalItemWrapper = newStyled.div(_templateObject39());
var VerticalCircleWrapper = newStyled.div(_templateObject40(), function (p) {
  return p.bg;
});
var TimelineCardContentWrapper = newStyled.div(_templateObject41(), function (p) {
  if (p.alternateCards) {
    return "width: 50%;";
  } else if (p.noTitle) {
    return "width: 90%;";
  } else {
    return "width: 75%;";
  }
}, function (p) {
  if (!p.flip) {
    return "\n        &.left {\n          order: 1;\n        }\n        &.right {\n          order: 3;\n        }\n      ";
  } else {
    return "\n        &.left {\n          order: 3;\n        }\n        &.right {\n          order: 1;\n        }\n      ";
  }
}, animateVisible);
var VerticalCircleContainer = newStyled.div(_templateObject42());
var TimelineTitleWrapper = newStyled.div(_templateObject43(), function (p) {
  return p.hide && p.mode === 'VERTICAL' ? 'none' : 'flex';
}, function (p) {
  return p.alternateCards ? 'width: 50%' : 'width: 15%';
}, function (p) {
  return p.flip ? 'flex-end' : 'flex-start';
}, function (p) {
  return p.flip && p.mode === 'VERTICAL_ALTERNATING' ? '1' : '3';
}, function (p) {
  return p.flip ? "\n      order: 3;\n      justify-content: flex-start;" : "order: 1;\n    justify-content: flex-end;";
});

var VerticalCircle = function VerticalCircle(props) {
  var className = props.className;
  var id = props.id;
  var _onClick2 = props.onClick;
  var active = props.active;
  var onActive = props.onActive;
  var theme = props.theme;
  var alternateCards = props.alternateCards;
  var slideShowRunning = props.slideShowRunning;
  var circleRef = useRef(null);
  useEffect(function () {
    if (active) {
      var circle = circleRef.current;
      circle && onActive(circle.offsetTop);
    }
  }, [active]);
  return React.createElement(VerticalCircleWrapper, {
    className: className,
    "data-testid": "tree-leaf",
    bg: theme && theme.primary,
    alternateCards: alternateCards,
    role: "button"
  }, React.createElement(VerticalCircleContainer, {
    className: "".concat(className, " timeline-vertical-circle"),
    onClick: function onClick(ev) {
      ev.stopPropagation();

      if (id && _onClick2 && !slideShowRunning) {
        _onClick2(id);
      }
    },
    ref: circleRef,
    role: "button",
    "data-testid": "tree-leaf-click",
    "aria-label": "select timeline"
  }, React.createElement(Circle, {
    className: active ? 'active' : 'in-active',
    theme: theme
  })));
};

var VerticalItem = function VerticalItem(props) {
  var contentRef = useRef(null);
  var active = props.active;
  var alternateCards = props.alternateCards;
  var cardDetailedText = props.cardDetailedText;
  var cardHeight = props.cardHeight;
  var cardSubtitle = props.cardSubtitle;
  var cardTitle = props.cardTitle;
  var className = props.className;
  var contentDetailsChildren = props.contentDetailsChildren;
  var hasFocus = props.hasFocus;
  var id = props.id;
  var index = props.index;
  var media = props.media;
  var mode = props.mode;
  var onActive = props.onActive;
  var onClick = props.onClick;
  var onElapsed = props.onElapsed;
  var slideItemDuration = props.slideItemDuration;
  var slideShowRunning = props.slideShowRunning;
  var theme = props.theme;
  var title = props.title;
  var visible = props.visible;
  var flipLayout = props.flipLayout;

  var handleOnActive = function handleOnActive(offset) {
    if (contentRef.current) {
      var ref = contentRef.current;
      var offsetTop = ref.offsetTop;
      var clientHeight = ref.clientHeight;
      onActive(offsetTop + offset, offsetTop, clientHeight);
    }
  }; // handler for read more


  var handleShowMore = useCallback(function () {
    setTimeout(function () {
      handleOnActive(0);
    }, 100);
  }, []); // timeline title

  var Title = useMemo(function () {
    return React.createElement(TimelineTitleWrapper, {
      className: className,
      alternateCards: alternateCards,
      mode: mode,
      hide: !title,
      flip: flipLayout
    }, React.createElement(TimelineItemTitle, {
      title: title,
      active: active,
      theme: theme,
      align: flipLayout ? 'left' : 'right'
    }));
  }, [active]);
  var verticalItemClass = useMemo(function () {
    var obj;
    return classnames((obj = {}, obj[className] = true, obj), 'vertical-item-row', visible ? 'visible' : '');
  }, []); // timeline card content

  var Content = useMemo(function () {
    var obj;
    var contentClass = classnames('card-content-wrapper', visible ? 'visible' : '', (obj = {}, obj[className] = true, obj));
    return React.createElement(TimelineCardContentWrapper, {
      className: contentClass,
      alternateCards: alternateCards,
      noTitle: !title,
      flip: flipLayout
    }, React.createElement(TimelineCardContent, {
      active: active,
      branchDir: className,
      cardHeight: cardHeight,
      content: cardSubtitle,
      customContent: contentDetailsChildren,
      detailedText: cardDetailedText,
      hasFocus: hasFocus,
      id: id,
      media: media,
      mode: mode,
      onClick: onClick,
      onElapsed: onElapsed,
      onShowMore: handleShowMore,
      slideItemDuration: slideItemDuration,
      slideShowActive: slideShowRunning,
      theme: theme,
      title: cardTitle
    }));
  }, [hasFocus, slideShowRunning, active]); // timeline circle

  var Circle = useMemo(function () {
    return React.createElement(VerticalCircle, {
      active: active,
      alternateCards: alternateCards,
      className: className,
      id: id,
      mode: mode,
      onActive: handleOnActive,
      onClick: onClick,
      slideShowRunning: slideShowRunning,
      theme: theme
    });
  }, [slideShowRunning, active]);
  return React.createElement(VerticalItemWrapper, {
    alternateCards: alternateCards,
    cardHeight: cardHeight,
    className: verticalItemClass,
    "data-testid": "vertical-item-row",
    key: index,
    ref: contentRef,
    role: "listitem"
  }, Title, Content, Circle);
};

var TimelineVertical = function TimelineVertical(ref) {
  var items = ref.items;
  var onClick = ref.onClick;
  var autoScroll = ref.autoScroll;
  var theme = ref.theme;
  var alternateCards = ref.alternateCards;
  if (alternateCards === void 0) alternateCards = true;
  var slideShowRunning = ref.slideShowRunning;
  var mode = ref.mode;
  var cardHeight = ref.cardHeight;
  var slideItemDuration = ref.slideItemDuration;
  var onElapsed = ref.onElapsed;
  var contentDetailsChildren = ref.contentDetailsChildren;
  var hasFocus = ref.hasFocus;
  var flipLayout = ref.flipLayout; // check if the timeline that has become active is visible.
  // if not auto scroll the content and bring it to the view.

  var handleOnActive = useCallback(function (offset, wrapperOffset, height) {
    autoScroll({
      timelinePointOffset: offset,
      timelineContentHeight: height,
      timelineContentOffset: wrapperOffset
    });
  }, []); // todo remove this

  var handleOnShowMore = useCallback(function () {}, []);
  return React.createElement(TimelineVerticalWrapper, {
    "data-testid": "tree-main",
    role: "list"
  }, items.map(function (item, index) {
    var className = ''; // in tree mode alternate cards position

    if (alternateCards) {
      className = index % 2 === 0 ? 'left' : 'right';
    } else {
      className = 'right';
    }

    var contentDetails = contentDetailsChildren && contentDetailsChildren[index] || null;
    return React.createElement(VerticalItem, Object.assign({}, item, {
      className: className,
      index: index,
      key: item.id,
      theme: theme,
      alternateCards: alternateCards,
      slideShowRunning: slideShowRunning,
      mode: mode,
      cardHeight: cardHeight,
      slideItemDuration: slideItemDuration,
      onShowMore: handleOnShowMore,
      onActive: handleOnActive,
      onClick: onClick,
      onElapsed: onElapsed,
      contentDetailsChildren: contentDetails,
      hasFocus: hasFocus,
      flipLayout: flipLayout
    }));
  }));
};

var Wrapper$1 = newStyled.div(_templateObject44(), function (p) {
  return p.cardPositionHorizontal === 'TOP' ? "\n    & > div:nth-of-type(1) {\n      order: 2;\n    }\n    & > div:nth-of-type(2) {\n      order: 1; \n    }\n    & > div:nth-of-type(3) {\n      order: 3;\n    }\n  " : '';
});
var TimelineMainWrapper = newStyled.div(_templateObject45(), function (p) {
  return p.scrollable ? 'auto' : 'hidden';
}, function (p) {
  return p.theme.primary;
}, function (p) {
  if (p.scrollable) {
    return p.scrollable instanceof Boolean && p.scrollable || p.scrollable.scrollbar ? '' : '0 1rem 0';
  }
}, function (p) {
  return p.theme.primary;
}, function (p) {
  return p.theme.primary;
});
var TimelineMain = newStyled.div(_templateObject46());
var Outline = newStyled.div(_templateObject47(), function (p) {
  return p.color;
});
var TimelineControlContainer$1 = newStyled.div(_templateObject48(), function (p) {
  if (p.active) {
    return "opacity(1);";
  } else {
    return "opacity(0.9);";
  }
});
var TimelineContentRender = newStyled.div(_templateObject49());

var Timeline = function Timeline(props) {
  // de-structure the props
  var activeTimelineItem = props.activeTimelineItem;
  var disableNavOnKey = props.disableNavOnKey;
  var itemWidth = props.itemWidth;
  if (itemWidth === void 0) itemWidth = 200;
  var items = props.items;
  if (items === void 0) items = [];
  var mode = props.mode;
  if (mode === void 0) mode = 'HORIZONTAL';
  var onNext = props.onNext;
  var onPrevious = props.onPrevious;
  var onTimelineUpdated = props.onTimelineUpdated;
  var slideShowRunning = props.slideShowRunning;
  var onLast = props.onLast;
  var onFirst = props.onFirst;
  var theme = props.theme;
  var onRestartSlideshow = props.onRestartSlideshow;
  var cardHeight = props.cardHeight;
  var slideShowEnabled = props.slideShowEnabled;
  var slideItemDuration = props.slideItemDuration;
  var hideControls = props.hideControls;
  var scrollable = props.scrollable;
  var cardPositionHorizontal = props.cardPositionHorizontal;
  var contentDetailsChildren = props.contentDetailsChildren;
  var flipLayout = props.flipLayout;
  var ref = useNewScrollPosition$1(mode, itemWidth);
  var newOffSet = ref[0];
  var setNewOffset = ref[1];
  var observer = useRef(null);
  var ref$1 = useState(false);
  var hasFocus = ref$1[0];
  var setHasFocus = ref$1[1]; // reference to the timeline

  var timelineMainRef = useRef(null);
  var canScrollTimeline = useMemo(function () {
    if (!slideShowRunning) {
      return scrollable;
    }
  }, [slideShowRunning, scrollable]); // generate a unique id for the timeline content

  var id = useRef(nanoid()); // handlers for navigation

  var handleNext = function handleNext() {
    return hasFocus && onNext();
  };

  var handlePrevious = function handlePrevious() {
    return hasFocus && onPrevious();
  };

  var handleFirst = function handleFirst() {
    return hasFocus && onFirst();
  };

  var handleLast = function handleLast() {
    return hasFocus && onLast();
  }; // handler for keyboard navigation


  var handleKeySelection = function handleKeySelection(event) {
    var key = event.key;

    if (mode === 'HORIZONTAL' && key === 'ArrowRight' || (mode === 'VERTICAL' || mode === 'VERTICAL_ALTERNATING') && key === 'ArrowDown') {
      handleNext();
    } else if (mode === 'HORIZONTAL' && key === 'ArrowLeft' || (mode === 'VERTICAL' || mode === 'VERTICAL_ALTERNATING') && key === 'ArrowUp') {
      handlePrevious();
    } else if (key === 'Home') {
      handleFirst();
    } else if (key === 'End') {
      handleLast();
    }
  };

  var handleTimelineItemClick = function handleTimelineItemClick(id, isSlideShow) {
    if (id) {
      for (var idx = 0; idx < items.length; idx++) {
        if (items[idx].id === id) {
          if (isSlideShow && idx < items.length - 1) {
            onTimelineUpdated(idx + 1);
          } else {
            onTimelineUpdated(idx);
          }

          break;
        }
      }
    }
  };

  var handleScroll = useCallback(function (scroll) {
    var element = timelineMainRef.current;

    if (element) {
      setNewOffset(element, scroll);
    }
  }, [setNewOffset]);
  useEffect(function () {
    var ele = timelineMainRef.current;

    if (!ele) {
      return;
    }

    if (mode === 'HORIZONTAL') {
      ele.scrollLeft = newOffSet;
    } else {
      ele.scrollTop = newOffSet;
    }
  }, [newOffSet]);
  useLayoutEffect(function () {
    // setup observer for the timeline elements
    setTimeout(function () {
      var element = timelineMainRef.current;

      if (element) {
        var childElements = element.querySelectorAll('.vertical-item-row');
        Array.from(childElements).forEach(function (elem) {
          if (observer.current) {
            observer.current.observe(elem);
          }
        });
      }
    }, 0);

    if (mode !== 'HORIZONTAL') {
      observer.current = new IntersectionObserver(function (entries) {
        // helper functions to hide image/videos
        var hide = function hide(ele) {
          return ele.style.visibility = 'hidden';
        };

        var show = function show(ele) {
          return ele.style.visibility = 'visible';
        };

        entries.forEach(function (entry) {
          var element = entry.target;

          if (entry.isIntersecting) {
            // show img and video when visible.
            element.querySelectorAll('img').forEach(show);
            element.querySelectorAll('video').forEach(show);
          } else {
            // hide img and video when not visible.
            element.querySelectorAll('img').forEach(hide);
            element.querySelectorAll('video').forEach(hide);
          }
        });
      }, {
        root: timelineMainRef.current,
        threshold: 0
      });
    }

    return function () {
      if (observer.current) {
        observer.current.disconnect();
      }
    }; // eslint-disable-next-line
  }, []);
  return React.createElement(Wrapper$1, {
    onKeyDown: function onKeyDown(evt) {
      return !disableNavOnKey && !slideShowRunning ? handleKeySelection(evt) : null;
    },
    className: "".concat(mode.toLowerCase(), " js-focus-visible focus-visible"),
    cardPositionHorizontal: cardPositionHorizontal,
    onClickCapture: function onClickCapture() {
      setHasFocus(true);
    }
  }, React.createElement(TimelineMainWrapper, {
    ref: timelineMainRef,
    scrollable: canScrollTimeline,
    className: "".concat(mode.toLowerCase(), " timeline-main-wrapper"),
    id: "timeline-main-wrapper",
    theme: theme
  }, mode === 'VERTICAL_ALTERNATING' ? React.createElement(TimelineVertical, {
    activeTimelineItem: activeTimelineItem,
    autoScroll: handleScroll,
    cardHeight: cardHeight,
    contentDetailsChildren: contentDetailsChildren,
    hasFocus: hasFocus,
    items: items,
    mode: mode,
    onClick: handleTimelineItemClick,
    onElapsed: function onElapsed(id) {
      return handleTimelineItemClick(id, true);
    },
    slideItemDuration: slideItemDuration,
    slideShowRunning: slideShowRunning,
    theme: theme,
    flipLayout: flipLayout
  }) : null, mode === 'HORIZONTAL' ? React.createElement(TimelineMain, {
    className: mode.toLowerCase()
  }, React.createElement(Outline, {
    color: theme && theme.primary
  }), React.createElement(TimelineHorizontal, {
    autoScroll: handleScroll,
    cardHeight: cardHeight,
    contentDetailsChildren: contentDetailsChildren,
    handleItemClick: handleTimelineItemClick,
    hasFocus: hasFocus,
    itemWidth: itemWidth,
    items: items,
    mode: mode,
    onElapsed: function onElapsed(id) {
      return handleTimelineItemClick(id, true);
    },
    slideItemDuration: slideItemDuration,
    slideShowRunning: slideShowRunning,
    theme: theme,
    wrapperId: id.current
  })) : null, mode === 'VERTICAL' ? React.createElement(TimelineVertical, {
    activeTimelineItem: activeTimelineItem,
    alternateCards: false,
    autoScroll: handleScroll,
    cardHeight: cardHeight,
    contentDetailsChildren: contentDetailsChildren,
    hasFocus: hasFocus,
    items: items,
    mode: mode,
    onClick: handleTimelineItemClick,
    onElapsed: function onElapsed(id) {
      return handleTimelineItemClick(id, true);
    },
    slideItemDuration: slideItemDuration,
    slideShowRunning: slideShowRunning,
    theme: theme,
    flipLayout: flipLayout
  }) : null), !hideControls && React.createElement(TimelineControlContainer$1, {
    mode: mode
  }, React.createElement(TimelineControl, {
    onNext: handleNext,
    onPrevious: handlePrevious,
    onFirst: handleFirst,
    onLast: handleLast,
    disableLeft: activeTimelineItem === 0,
    disableRight: activeTimelineItem === items.length - 1,
    mode: mode,
    theme: theme,
    onReplay: onRestartSlideshow,
    slideShowRunning: slideShowRunning,
    slideShowEnabled: slideShowEnabled,
    id: id.current
  })), React.createElement(TimelineContentRender, {
    id: id.current
  }));
};

var Chrono = function Chrono(ref) {
  var items = ref.items;
  var itemWidth = ref.itemWidth;
  if (itemWidth === void 0) itemWidth = 300;
  var mode = ref.mode;
  if (mode === void 0) mode = 'HORIZONTAL';
  var disableNavOnKey = ref.disableNavOnKey;
  if (disableNavOnKey === void 0) disableNavOnKey = false;
  var slideShow = ref.slideShow;
  if (slideShow === void 0) slideShow = false;
  var slideItemDuration = ref.slideItemDuration;
  if (slideItemDuration === void 0) slideItemDuration = 5000;
  var theme = ref.theme;
  if (theme === void 0) theme = {
    primary: '#0f52ba',
    secondary: '#ffdf00'
  };
  var cardHeight = ref.cardHeight;
  if (cardHeight === void 0) cardHeight = 200;
  var hideControls = ref.hideControls;
  if (hideControls === void 0) hideControls = false;
  var scrollable = ref.scrollable;
  if (scrollable === void 0) scrollable = true;
  var cardPositionHorizontal = ref.cardPositionHorizontal;
  if (cardPositionHorizontal === void 0) cardPositionHorizontal = 'BOTTOM';
  var children = ref.children;
  var flipLayout = ref.flipLayout;
  var ref$1 = useState([]);
  var timeLineItems = ref$1[0];
  var setItems = ref$1[1];
  var timeLineItemsRef = useRef();
  var ref$2 = useState(false);
  var slideShowActive = ref$2[0];
  var setSlideshowActive = ref$2[1];
  var ref$3 = useState(0);
  var activeTimelineItem = ref$3[0];
  var setActiveTimelineItem = ref$3[1];

  var initItems = function initItems() {
    return items && items.length ? items.map(function (item, index) {
      return Object.assign({}, item, {
        id: nanoid(),
        visible: true,
        active: index === 0
      });
    }) : Array.from({
      length: children.length
    }).map(function (item, index) {
      return {
        id: nanoid(),
        visible: true,
        active: index === 0
      };
    });
  };

  useEffect(function () {
    var items = initItems();
    timeLineItemsRef.current = items;
    setItems(items);
  }, []);
  var handleTimelineUpdate = useCallback(function (actvTimelineIndex) {
    setItems(function (items) {
      return items.map(function (item, index) {
        return Object.assign({}, item, {
          active: index === actvTimelineIndex
        });
      });
    });
    setActiveTimelineItem(actvTimelineIndex);

    if (items) {
      if (items.length - 1 === actvTimelineIndex) {
        setSlideshowActive(false);
      }
    }
  }, []);
  var restartSlideShow = useCallback(function () {
    setSlideshowActive(true);
    handleTimelineUpdate(0);
  }, []);

  var handleOnNext = function handleOnNext() {
    if (!timeLineItems.length) {
      return;
    }

    if (activeTimelineItem < timeLineItems.length - 1) {
      var newTimeLineItem = activeTimelineItem + 1;
      handleTimelineUpdate(newTimeLineItem);
      setActiveTimelineItem(newTimeLineItem);
    }
  };

  var handleOnPrevious = function handleOnPrevious() {
    if (activeTimelineItem > 0) {
      var newTimeLineItem = activeTimelineItem - 1;
      handleTimelineUpdate(newTimeLineItem);
      setActiveTimelineItem(newTimeLineItem);
    }
  };

  var handleFirst = function handleFirst() {
    setActiveTimelineItem(0);
    handleTimelineUpdate(0);
  };

  var handleLast = function handleLast() {
    if (timeLineItems.length) {
      var idx = timeLineItems.length - 1;
      setActiveTimelineItem(idx);
      handleTimelineUpdate(idx);
    }
  };

  return React.createElement(Timeline, {
    activeTimelineItem: activeTimelineItem,
    cardHeight: cardHeight,
    cardPositionHorizontal: cardPositionHorizontal,
    contentDetailsChildren: children,
    disableNavOnKey: disableNavOnKey,
    hideControls: hideControls,
    itemWidth: itemWidth,
    items: timeLineItems,
    mode: mode,
    onFirst: handleFirst,
    onLast: handleLast,
    onNext: handleOnNext,
    onPrevious: handleOnPrevious,
    onRestartSlideshow: restartSlideShow,
    onTimelineUpdated: useCallback(handleTimelineUpdate, []),
    scrollable: scrollable,
    slideItemDuration: slideItemDuration,
    slideShow: slideShow,
    slideShowEnabled: slideShow,
    slideShowRunning: slideShowActive,
    theme: theme,
    flipLayout: flipLayout
  });
};

export { Chrono };